import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
import { NAVBAR_TRACKING } from '../constants';
var DEFAULT_PAGE = NAVBAR_TRACKING.home;
var NULL_VALUES = new Set([undefined, null, '', 'not set']);
var cleanValue = function cleanValue(value) {
  if (NULL_VALUES.has(value)) {
    return 'null';
  }
  return String(value).trim().toLowerCase().replace(/\s+/g, '_');
};
export var getCurrentPage = function getCurrentPage() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (pathname.includes('/settings')) return NAVBAR_TRACKING.settings;
  if (pathname.includes('/plan')) return NAVBAR_TRACKING.pricing;
  return DEFAULT_PAGE;
};
export var getSettingsLevel4 = function getSettingsLevel4() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = name.toLowerCase();
  if (value.includes('work')) return NAVBAR_TRACKING.work_info;
  if (value.includes('linked')) return NAVBAR_TRACKING.linked_accounts;
  if (value.includes('password')) return NAVBAR_TRACKING.change_password;
  return NAVBAR_TRACKING.user_info;
};
export var formatNavValue = cleanValue;
export var MY_ACCOUNT_LABEL_MAP = {
  Settings: NAVBAR_TRACKING.settings,
  Logout: NAVBAR_TRACKING.logout,
  'Get Help': NAVBAR_TRACKING.get_help,
  'Go To AJE': NAVBAR_TRACKING.go_to_aje
};
var buildPayload = function buildPayload(_ref) {
  var _ref$level = _ref.level1,
    level1 = _ref$level === void 0 ? null : _ref$level,
    _ref$level2 = _ref.level2,
    level2 = _ref$level2 === void 0 ? null : _ref$level2,
    _ref$level3 = _ref.level3,
    level3 = _ref$level3 === void 0 ? null : _ref$level3,
    _ref$level4 = _ref.level4,
    level4 = _ref$level4 === void 0 ? null : _ref$level4,
    _ref$elementType = _ref.elementType,
    elementType = _ref$elementType === void 0 ? null : _ref$elementType,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? DEFAULT_PAGE : _ref$page;
  return {
    level_1: cleanValue(level1),
    level_2: cleanValue(level2),
    level_3: cleanValue(level3),
    level_4: cleanValue(level4),
    element_type: cleanValue(elementType),
    page: cleanValue(page)
  };
};
var trackNavigationClick = function trackNavigationClick() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  trackRubriqEvent('Navigation Item Clicked', buildPayload(payload));
};

/* Common reusable trackers */

export var trackTabClick = function trackTabClick(level1, page) {
  return trackNavigationClick({
    level1: level1,
    elementType: NAVBAR_TRACKING.tab,
    page: page
  });
};
export var trackDropdownClick = function trackDropdownClick(level1, page) {
  return trackNavigationClick({
    level1: level1,
    elementType: NAVBAR_TRACKING.dropdown,
    page: page
  });
};
export var trackDropdownItemClick = function trackDropdownItemClick(_ref2) {
  var level1 = _ref2.level1,
    label = _ref2.label,
    page = _ref2.page,
    _ref2$level = _ref2.level2,
    level2 = _ref2$level === void 0 ? null : _ref2$level,
    _ref2$level2 = _ref2.level4,
    level4 = _ref2$level2 === void 0 ? null : _ref2$level2,
    _ref2$map = _ref2.map,
    map = _ref2$map === void 0 ? {} : _ref2$map;
  return trackNavigationClick({
    level1: level1,
    level2: level2,
    level3: map[label] || cleanValue(label),
    level4: level4,
    elementType: NAVBAR_TRACKING.dropdown_item,
    page: page
  });
};
export var trackServiceClick = function trackServiceClick(serviceName, page) {
  return trackNavigationClick({
    level1: 'services',
    level3: serviceName,
    elementType: NAVBAR_TRACKING.dropdown_item,
    page: page
  });
};
export var trackSettingsTabClick = function trackSettingsTabClick(tabName) {
  return trackNavigationClick({
    level1: NAVBAR_TRACKING.my_account,
    level3: NAVBAR_TRACKING.settings,
    level4: getSettingsLevel4(tabName),
    elementType: NAVBAR_TRACKING.tab,
    page: NAVBAR_TRACKING.settings
  });
};
export var trackTryFreeClick = function trackTryFreeClick() {
  return trackNavigationClick({
    level2: NAVBAR_TRACKING.try_free,
    elementType: NAVBAR_TRACKING.button,
    page: NAVBAR_TRACKING.home
  });
};
export var trackLogoClick = function trackLogoClick() {
  return trackNavigationClick({
    level1: NAVBAR_TRACKING.rubriq,
    elementType: NAVBAR_TRACKING.tab,
    page: NAVBAR_TRACKING.home
  });
};
export var trackUpgradeClick = function trackUpgradeClick() {
  return trackNavigationClick({
    level1: null,
    level2: NAVBAR_TRACKING.upgrade,
    elementType: NAVBAR_TRACKING.button,
    page: NAVBAR_TRACKING.pricing
  });
};
export var trackSubscriptionEndedClick = function trackSubscriptionEndedClick() {
  return trackNavigationClick({
    level1: null,
    level2: NAVBAR_TRACKING.reactivate,
    elementType: NAVBAR_TRACKING.button,
    page: NAVBAR_TRACKING.dashboard
  });
};
export default trackNavigationClick;